import type { Chain } from "viem"
import * as chains from "viem/chains"
import * as customChains from "../../chains"
import type { SupportedChainId } from "../../config"

export const NATIVES: Record<SupportedChainId, Chain["nativeCurrency"]> = {
  [chains.mainnet.id]: chains.mainnet.nativeCurrency,
  [chains.base.id]: chains.base.nativeCurrency,
  [chains.sepolia.id]: chains.sepolia.nativeCurrency,
  [chains.foundry.id]: chains.foundry.nativeCurrency,
  [chains.arbitrum.id]: chains.arbitrum.nativeCurrency,
  [customChains.tenderly.id]: customChains.tenderly.nativeCurrency,
  [customChains.bartio.id]: customChains.bartio.nativeCurrency,
  [customChains.swell.id]: customChains.swell.nativeCurrency,
  [customChains.sonic.id]: customChains.sonic.nativeCurrency,
  [customChains.berachain.id]: customChains.berachain.nativeCurrency,
  [customChains.ink.id]: customChains.ink.nativeCurrency,
  [customChains.unichain.id]: customChains.unichain.nativeCurrency,
  [chains.avalanche.id]: chains.avalanche.nativeCurrency,
  [customChains.bob.id]: customChains.bob.nativeCurrency,
  [chains.bsc.id]: chains.bsc.nativeCurrency,
  [customChains.hyperevm.id]: customChains.hyperevm.nativeCurrency,
  [customChains.tac.id]: customChains.tac.nativeCurrency,
  [chains.linea.id]: chains.linea.nativeCurrency,
  [chains.mantle.id]: chains.mantle.nativeCurrency,
  [customChains.plasma.id]: customChains.plasma.nativeCurrency,
  [customChains.monad.id]: customChains.monad.nativeCurrency,
}
